import { memo, useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCreateBranch } from "../../../../hooks/query/useCreateBranch";
import { useGetAllBranch } from "../../../../hooks/query/useGetAllBranch";
import InputText from "../../../InputText";
import WarningDeleteBranchPopup from "../../../WarningDeleteBranchPopup";
import BranchTag from "../../BranchTag";

function Branch() {
    const [name, setName] = useState("");
    const [address, setAddress] = useState("");
    const [phone, setPhone] = useState("");
    const [show, setShow] = useState<boolean>(false);
    const [branchId, setBranchId] = useState<number | null>(null);
    const { data, isLoading } = useGetAllBranch(1,10);
    const { mutate: createBranch } = useCreateBranch();

    const handleCreateBranch = useCallback(() => {
        createBranch(
            { name, address, phone },
            {
                onSuccess: () => {
                    setName("");
                    setAddress("");
                    setPhone("");
                    toast.success("Tạo chi nhánh thành công!");
                },
            }
        );
    }, [name, address, phone, createBranch]);

    const handleDeleteBranch = (branchId: number) => {
        setShow(true);
        setBranchId(branchId);
    }

    const handleCloseDeletePopup = () => {
        setShow(false);
        setBranchId(null);
    };

    return (<div className="mt-[20px] w-full h-full">
        {show && (<WarningDeleteBranchPopup
            branchId={branchId}
            onClose={handleCloseDeletePopup}
            onCancel={handleCloseDeletePopup}
            onSuccess={() => {
                toast.success("Xóa file thành công!");
            }}
        />)}
        <div>
            <h1 className="font-bold text-[20px] text-center">Tạo mới chi nhánh</h1>
            <div className="w-[30%] mt-[20px]">
                <InputText value={name} onChange={(e) => setName(e.target.value)} label="Tên chi nhánh" placeholder="Nhập tên chi nhánh..." name="name" inputStyle="text-black" />
                <InputText value={address} onChange={(e) => setAddress(e.target.value)} label="Địa chỉ" placeholder="Nhập địa chỉ chi nhánh..." name="address" inputStyle="text-black" />
                <InputText value={phone} onChange={(e) => setPhone(e.target.value)} label="Số điện thoại" placeholder="Nhập số điện thoại chi nhánh..." name="phone" inputStyle="text-black" />
                <button onClick={handleCreateBranch} className="mt-[15px] bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Tạo chi nhánh</button>
            </div>
            <div>
                <hr className="my-6" />
                <h2 className="font-bold text-[20px] my-[10px] text-center">Danh sách chi nhánh</h2>
                {isLoading && <p>Loading...</p>}
                <div className="space-y-2">
                    {data?.data?.items
                        ?.slice()
                        .sort((a: any, b: any) => a.id - b.id)
                        .map((branch: any) => (
                            <BranchTag
                                key={branch.id}
                                branch={branch}
                                onEdit={(id: number) => { }}
                                onDelete={(id: number) => {
                                    handleDeleteBranch(id);
                                }}
                            />
                        ))}
                </div>
            </div>
        </div>
    </div>);
}

export default memo(Branch);